var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVision(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M90.56 91.17 80 67.9 68.55 42.39a1.35 1.35 0 0 0-.32-.42l-7.12-8a.89.89 0 0 0-1.49.85l9.46 33.08a1 1 0 0 1-.31 1.28l-11.59 11.9a1.62 1.62 0 0 0-.32 1.92l5.31 11a1.75 1.75 0 0 0 1.6 1h29.87a1.38 1.38 0 0 0 0-2.76h-1.48a1.64 1.64 0 0 1-1.6-1.07zM57.71 38 66 66.94a1.78 1.78 0 0 1-.42 1.7l-11.81 12a1.49 1.49 0 0 0-.31 1.6l5 10.2a1.8 1.8 0 0 1-1.6 2.56H6.36a1.38 1.38 0 0 1 0-2.76h3.5a.81.81 0 0 0 .54-.24l14.14-13.26a1.35 1.35 0 0 0 .42-1l3-17.32a1.13 1.13 0 0 1 .53-1l6.38-5.63a1.72 1.72 0 0 1 2.66.43L49.42 74.7a1.35 1.35 0 0 0 2.33-1.38l-9.88-16.9a1.8 1.8 0 0 1 0-1.8l12.75-21.37a1.35 1.35 0 0 0 .32-.85v-26a1.4 1.4 0 0 1 1.92-1.28l17.22 7.44a1.42 1.42 0 0 1 0 2.55l-15.41 6.56a1.87 1.87 0 0 0-1.07 1.59v14.35c0 .11.11.32.11.43z",
    fill: "#107988",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVision);
export default __webpack_public_path__ + "static/media/vision.1289a8a445416802e2f6e9c9e0c39dc3.svg";
export { ForwardRef as ReactComponent };